import { fetcher } from "utils";
import { IPage, IJSendSuccessResponse, IWithMeta, CartSerialized, IPageMeta } from "typings";

export function get__api__v1__members__carts(params: {
  page: IPage;
}): Promise<IJSendSuccessResponse<IWithMeta<CartSerialized[], IPageMeta>>> {
  return fetcher.get("/api/v1/members/carts", params);
}
